import React from "react";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  CheckboxVisibility,
  TextField,
  PrimaryButton,
  DefaultButton,
} from "office-ui-fabric-react";
import * as axios from "../axios/users";
import request from "axios";
import config from "../config";
import StatusBar from "./common/StatusBar";
import _ from "lodash";

export class ZipCodeAssignment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      isLoading: false,
      showDialogDelete: false,
      showComments: false,
      showReminderDate: false,
      columns: columns,
      data: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(axios.list());
  }

  close() {
    this.setState({
      showDialog: false,
      data: {},
    });
  }

  save() {
    var user = this.state.data;
    var zipCodes = user.zipCodes || "";
    this.props.dispatch(
      axios.update({
        _id: user._id,
        managerId: null,
        accountType: "manager",
        zipCodes: "",
      })
    );

    zipCodes = zipCodes
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e);

    if (zipCodes && zipCodes.length > 0) {
      request
        .post(`${config.apiUrl}/zipcode/reassign`, {
          zipCodes: zipCodes,
        })
        .then(() => {})
        .catch((e) => alert("Error"));
    }

    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      this.setState({
        showDialog: false,
        isLoading: false,
      });
      this.rowSelected = null;
    }, 1000);
  }

  show(e) {
    this.rowSelected = e;
    this.setState({
      showDialog: true,
      data: e,
    });
  }

  render() {
    var columns = this.state.columns;
    var users = this.props.users;
    if (this.props.auth.user.accountType == "admin") {
      var processCollum = columns.find((e) => e.key == "action");
      processCollum.onRender = (e) => {
        return (
          <div>
            <button className="tbl-btn" onClick={() => this.show(e)}>
              <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
            </button>
          </div>
        );
      };
    } else {
      columns = columns.filter((e) => e.key != "action");
    }

    return (
      <div style={{ margin: 10 }}>
        {users.error ? (
          <div className="ms-fontColor-red">Error</div>
        ) : !users.data ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div style={{ marginBottom: 30 }}>
            <DetailsList
              items={users.data.filter((e) => e.accountType == "staff")}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              style={{ fontSize: 14 }}
            />
            <StatusBar>
              <span>Total: {users.data.length}</span>
              {this.state.data._id && (
                <span>
                  {" "}
                  | Selected: #{users.data.indexOf(this.state.data) + 1} -{" "}
                  {`${this.state.data.fname} ${this.state.data.lname}`}{" "}
                </span>
              )}
            </StatusBar>
          </div>
        )}
        {this.state.data._id && (
          <Dialog
            isOpen={this.state.showDialog}
            title="Move staff to manager"
            isBlocking={false}
            closeButtonAriaLabel="Close"
            containerClassName="info-list-modal"
            onDismiss={() => this.close()}
          >
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Name"
                    value={this.state.data.fname + " " + this.state.data.lname}
                    disabled={true}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Email"
                    value={this.state.data.email}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <DialogFooter>
              <PrimaryButton onClick={() => this.save()}>
                {this.state.isLoading ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Spinner size={SpinnerSize.xSmall} />
                    {" Assigning..."}
                  </div>
                ) : (
                  <span>Assign to a Manager Role</span>
                )}
              </PrimaryButton>
              <DefaultButton onClick={() => this.close()}>Cancel</DefaultButton>
            </DialogFooter>
          </Dialog>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  users: state.users,
  customer: state.customer,
}))(ZipCodeAssignment);

const columns = [
  {
    key: "fname",
    name: "First name",
    fieldName: "fname",
    minWidth: 50,
    maxWidth: 120,
  },
  {
    key: "lname",
    name: "Last name",
    fieldName: "lname",
    minWidth: 50,
    maxWidth: 120,
  },
  {
    key: "email",
    name: "Email address",
    fieldName: "email",
    minWidth: 250,
    maxWidth: 250,
  },
  // {
  //     key: 'zipCodes',
  //     name: 'Zip Codes',
  //     fieldName: 'zipCodes',
  //     isMultiline: true,
  //     onRender: (item) => {
  //         return (item
  //             .zipCodes || '')
  //             .split(',')
  //             .map(e => e.trim())
  //             .join(', ');
  //     }
  // },
  {
    key: "role",
    name: "Role",
    fieldName: "accountType",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "action",
    name: "",
    fieldName: "action",
    minWidth: 80,
    maxWidth: 80,
  },
];



// WEBPACK FOOTER //
// ./client/components/StaffToManager.js